/* Amalife — buy-box behaviour.
   1) Bundle picker: 1 / 2 / 3 бр. + комбинация с друг продукт
   2) (window.amaI18n && window.amaI18n.quick_order || "Бърза поръчка"): name, phone and email, sends a callback request
   The cart-drawer upsell needs no JS here: it reuses Wonder's <product-form>. */
(function () {
  'use strict';

  var NL = String.fromCharCode(10);

  function addUrl() {
    return (window.routes && window.routes.cart_add_url) || '/cart/add';
  }

  function formFor(el) {
    var host = el.closest('product-form') ||
               el.closest('.wt-product__add-to-cart_form') ||
               el.parentElement;
    var form = host && host.querySelector('form[action*="/cart/add"]');
    return form || document.querySelector('form[action*="/cart/add"]');
  }

  function mainAddButton(el) {
    var id = el.getAttribute && el.getAttribute('data-add-button');
    return (id && document.getElementById(id)) ||
           document.querySelector('.js-add-to-cart[name="add"]');
  }

  /* ======================================================================
     1 · Bundle picker
     ====================================================================== */

  var selectedPartner = null;

  /* price.liquid renders the same markup for the buy box, the sticky bar, the
     predictive-search dropdown and product cards — and the MutationObserver at
     the bottom re-runs syncPrice on every DOM change. So a document-wide query
     rewrote the search results' price to the open product's the instant the
     dropdown appeared: searching EPA-3 from the Cimicifuga page showed
     Cimicifuga's €23,82. Only these two places are this product's own price. */
  function productPriceNodes() {
    var out = [];
    document.querySelectorAll('.wt-product__main, .wt-product__sticky-buy__wrapper')
      .forEach(function (root) {
        root.querySelectorAll('.wt-product__price__final')
          .forEach(function (el) { out.push(el); });
      });
    return out;
  }

  function quantityInput() {
    return document.querySelector('.wt-product__add-to-cart_form input[name="quantity"]') ||
           document.querySelector('form[action*="/cart/add"] input[name="quantity"]') ||
           document.querySelector('.js-counter-quantity');
  }

  /* Mirror the chosen bundle in the main product price, so the figure under the
     title is what the shopper will actually pay. The struck-through original is
     injected here rather than reusing Wonder's .wt-product__price__compare —
     that one lives in the .price__sale block, which stays hidden unless the
     product itself is on sale. */
  function syncPrice(input) {
    var total = input && input.getAttribute('data-total');
    var compare = input && input.getAttribute('data-compare');

    productPriceNodes().forEach(function (el) {
      if (el.dataset.amaOrigPrice === undefined) {
        el.dataset.amaOrigPrice = el.textContent.trim();
      }
      var wanted = total || el.dataset.amaOrigPrice;
      if (el.textContent.trim() !== wanted) el.textContent = wanted;

      var priceRoot = el.closest('.price');
      var onSale = priceRoot && priceRoot.classList.contains('price--on-sale');
      var isSale = !!el.closest('.price__sale');
      var nativeWas = priceRoot && priceRoot.querySelector('.wt-product__price__compare');
      if (onSale && nativeWas) {
        var originalCompare = input.closest('[data-ama-bundle]').getAttribute('data-compare-unit');
        var qty = parseInt(input.getAttribute('data-qty'), 10) || 1;
        var saleCompare = compare || (originalCompare ? money(Number(originalCompare) * qty) : '');
        if (saleCompare && nativeWas.textContent.trim() !== saleCompare) nativeWas.textContent = saleCompare;
        var badge = priceRoot.querySelector('.price-item--percent');
        var totalCents = Number(input.getAttribute('data-total-cents'));
        var compareCents = Number(input.getAttribute('data-compare-cents'));
        if (badge && compareCents > 0) {
          var badgeText = '-' + Math.floor((compareCents - totalCents) * 100 / compareCents) + '%';
          if (badge.textContent.trim() !== badgeText) badge.textContent = badgeText;
        }
      }
      var was = el.parentElement.querySelector('.ama-price-was');
      if (onSale || isSale) { if (was) was.remove(); return; }
      if (compare) {
        if (!was) {
          was = document.createElement('s');
          was.className = 'ama-price-was';
          el.insertAdjacentElement('afterend', was);
        }
        if (was.textContent !== compare) was.textContent = compare;
      } else if (was) {
        was.remove();
      }
    });
  }

  /* ------------------------------------------------------------------ variants

     The bundle rows are priced in Liquid from the variant that happened to be
     selected when the page rendered, and syncPrice then writes that figure into
     the product price and remembers it. With one variant that was invisible.
     The moment a product carries two variants at different prices — the Argà
     bronzer, Sahara at a promo price and Marocco at full — switching shade left
     both the bundle rows and the headline price showing the other shade's money,
     while the form correctly submitted the chosen variant. Wonder does not
     re-render the price block here either, so nothing else was going to fix it.

     So: learn the shop's money format from what the page already rendered, and
     recompute every bundle row from the newly selected variant. */

  var priceFmt = null;
  function learnFormat() {
    if (priceFmt) return priceFmt;
    var el = productPriceNodes()[0];
    var txt = el && (el.dataset.amaOrigPrice || el.textContent).trim();
    var m = txt && txt.match(/^(\D*)([\d.,\s]+?)(\D*)$/);
    if (!m) return null;
    var num = m[2].trim();
    priceFmt = {
      pre: m[1], post: m[3],
      dec: num.lastIndexOf(',') > num.lastIndexOf('.') ? ',' : '.',
      group: /\s/.test(num) ? ' ' : (num.replace(/[.,]\d\d$/, '').indexOf('.') > -1 ? '.' : '')
    };
    return priceFmt;
  }
  function money(cents) {
    var f = learnFormat();
    var v = (Math.round(cents) / 100).toFixed(2);
    if (!f) return v;
    var parts = v.split('.');
    if (f.group) parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, f.group);
    return f.pre + parts[0] + f.dec + parts[1] + f.post;
  }

  var productCache = null;
  function productJson() {
    if (productCache) return Promise.resolve(productCache);
    var path = location.pathname.split('?')[0].replace(/\/$/, '');
    return fetch(path + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (j) {
        if (window.Shopify && Shopify.currency && Shopify.currency.active === 'EUR') {
          (j.variants || []).forEach(function (v) {
            var promo = window.amaPromoCatalog && window.amaPromoCatalog[String(v.id)];
            if (promo && v.price === promo.base) v.price = promo.sale;
          });
        }
        productCache = j; return j;
      })
      .catch(function () { return null; });
  }

  function currentVariantId() {
    var f = document.querySelector('form[action*="/cart/add"] input[name="id"]');
    return f ? String(f.value) : null;
  }

  /* Match the live cart: round each payable line total once.
     A combo has two separate lines. Compare-at is display-only. */
  function repriceBundle(variant) {
    var box = document.querySelector('[data-ama-bundle]');
    if (!box || !variant) return;
    var unit = variant.price;
    var compareUnit = Math.max(unit, variant.compare_at_price || 0);
    box.setAttribute('data-compare-unit', compareUnit);
    box.querySelectorAll('input[type="radio"]').forEach(function (input) {
      var qty = parseInt(input.getAttribute('data-qty'), 10) || 1;
      var pct = parseInt(input.getAttribute('data-percent'), 10) || 0;
      /* a combination is one of ours plus one of the partner's, so its base moves
         with the variant too — the partner's own price is carried on the input */
      var base = input.value === 'combo'
        ? unit + (parseInt(input.getAttribute('data-partner-price'), 10) || 0)
        : unit * qty;
      var now = input.value === 'combo'
        ? Math.floor((unit * (100 - pct) + 50) / 100) + Math.floor(((parseInt(input.getAttribute('data-partner-price'), 10) || 0) * (100 - pct) + 50) / 100)
        : Math.floor((base * (100 - pct) + 50) / 100);
      var save = base - now;
      var compareBase = input.value === 'combo' ? compareUnit + (parseInt(input.getAttribute('data-partner-compare'), 10) || parseInt(input.getAttribute('data-partner-price'), 10) || 0) : compareUnit * qty;
      input.setAttribute('data-total', money(now));
      input.setAttribute('data-compare', compareBase > now ? money(compareBase) : '');
      input.setAttribute('data-total-cents', now);
      input.setAttribute('data-compare-cents', compareBase);
      var row = input.closest('.ama-bundle__opt');
      if (!row) return;
      var nowEl = row.querySelector('.ama-bundle__now .ama-price__eur') || row.querySelector('.ama-bundle__now');
      if (nowEl) nowEl.textContent = money(now);
      var wasEl = row.querySelector('.ama-bundle__was');
      if (!wasEl && compareBase > now) {
        wasEl = document.createElement('s');
        wasEl.className = 'ama-bundle__was';
        row.querySelector('.ama-bundle__price').appendChild(wasEl);
      }
      if (wasEl) { wasEl.textContent = money(compareBase); wasEl.hidden = compareBase <= now; }
      var saveEl = row.querySelector('.ama-bundle__save');
      if (saveEl && pct > 0) saveEl.textContent = (window.amaI18n && window.amaI18n.you_save || 'Спестяваш') + ' ' + money(save);
    });
  }

  var lastVariant = null;
  function onVariantChange() {
    var id = currentVariantId();
    if (!id || id === lastVariant) return;
    lastVariant = id;
    productJson().then(function (j) {
      if (!j) return;
      var v = j.variants.filter(function (x) { return String(x.id) === id; })[0];
      if (!v) return;
      /* let the headline price follow the new variant instead of the pinned one */
      productPriceNodes().forEach(function (el) {
        el.dataset.amaOrigPrice = money(v.price);
      });
      repriceBundle(v);
      var checked = document.querySelector('[data-ama-bundle] input[type="radio"]:checked');
      if (checked) syncPrice(checked);
      else {
        productPriceNodes().forEach(function (el) {
          el.textContent = money(v.price);
        });
      }
    });
  }

  document.addEventListener('change', function (e) {
    if (e.target && e.target.closest && e.target.closest('form[action*="/cart/add"], variant-selects, variant-radios, fieldset')) {
      setTimeout(onVariantChange, 60);
    }
  });
  window.addEventListener('popstate', function () { setTimeout(onVariantChange, 60); });

  function applyChoice(input) {
    var box = input.closest('[data-ama-bundle]');
    if (!box) return;

    box.querySelectorAll('.ama-bundle__opt').forEach(function (label) {
      label.classList.toggle('is-selected', label.contains(input));
    });

    var qty = parseInt(input.getAttribute('data-qty'), 10) || 1;
    var field = quantityInput();
    if (field) {
      field.value = String(qty);
      field.dispatchEvent(new Event('input', { bubbles: true }));
      field.dispatchEvent(new Event('change', { bubbles: true }));
    }

    selectedPartner = input.getAttribute('data-partner') || null;
    syncPrice(input);
  }

  /* A combination is two different products at one unit each, so the quantity
     tiers in the discount function cannot see it. Both lines are stamped with a
     hidden `_ama_combo` line property instead, and the function grants the combo
     percentage to lines carrying it. Underscore-prefixed properties stay hidden
     from the shopper in cart and checkout. */
  var COMBO_PROP = 'properties[_ama_combo]';

  /* Stamp the form that is actually being submitted. A PDP carries several
     /cart/add forms (buy box, sticky bar, drawer add-ons), so picking one with
     document.querySelector marked the wrong line — the partner arrived flagged
     and the main product did not. */
  function flagComboLine(form, on) {
    if (!form) return;
    var field = form.querySelector('[name="' + COMBO_PROP + '"]');
    if (on) {
      if (!field) {
        field = document.createElement('input');
        field.type = 'hidden';
        field.name = COMBO_PROP;
        form.appendChild(field);
      }
      field.value = '1';
    } else if (field) {
      field.remove();
    }
  }

  function currentChoice() {
    return document.querySelector('[data-ama-bundle] input[type="radio"]:checked');
  }

  document.addEventListener('change', function (event) {
    var input = event.target;
    if (input && input.matches && input.matches('[data-ama-bundle] input[type="radio"]')) {
      applyChoice(input);
    }
  });

  function addPartner() {
    if (!selectedPartner) return Promise.resolve();
    var data = new FormData();
    data.append('id', selectedPartner);
    data.append('quantity', '1');
    data.append(COMBO_PROP, '1');
    return fetch(addUrl(), {
      method: 'POST',
      headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' },
      body: data
    }).catch(function () { /* partner add failed — still add the main product */ });
  }

  /* The combination choice needs a second line item. Add the partner first,
     then let Wonder's <product-form> run its normal submit so the drawer
     re-renders with both products. */
  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form || !form.matches || !form.matches('form[action*="/cart/add"]')) return;

    if (!selectedPartner) {
      flagComboLine(form, false);   // a stale flag from an earlier choice must not ride along
      return;
    }
    if (form.dataset.amaPartnerDone === 'true') {
      delete form.dataset.amaPartnerDone;
      return;
    }

    event.preventDefault();
    event.stopImmediatePropagation();

    addPartner().then(function () {
      flagComboLine(form, true);
      form.dataset.amaPartnerDone = 'true';
      if (form.requestSubmit) form.requestSubmit();
      else form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
    });
  }, true);

  /* ======================================================================
     2 · Quick order — name, phone and email
     ====================================================================== */

  var openerButton = null;

  function modal() { return document.querySelector('[data-ama-qo]'); }

  function openModal(btn) {
    var m = modal();
    if (!m) return false;
    if (btn) openerButton = btn;
    m.classList.add('is-open');
    m.setAttribute('aria-hidden', 'false');
    document.body.classList.add('ama-qo-open');
    var first = m.querySelector('input[name="contact[name]"]');
    if (first) setTimeout(function () { first.focus(); }, 30);
    return true;
  }

  function closeModal() {
    var m = modal();
    if (!m) return;
    m.classList.remove('is-open');
    m.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('ama-qo-open');
    if (openerButton) openerButton.focus();
  }

  function fail(msg) {
    var box = document.querySelector('[data-ama-qo-error]');
    if (!box) return;
    box.textContent = msg;
    box.hidden = false;
  }

  /* add the current buy-box selection (and the bundle partner) to the cart */
  function addCurrentSelection() {
    var form = document.querySelector('form[action*="/cart/add"]');
    if (!form) return Promise.resolve();
    var data = new FormData(form);
    if (!data.get('id')) return Promise.reject(new Error('no variant'));
    if (selectedPartner && !data.get(COMBO_PROP)) data.append(COMBO_PROP, '1');

    return fetch(addUrl(), {
      method: 'POST',
      headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' },
      body: data
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res && res.status) throw new Error(res.description || 'add failed');
        return addPartner();
      });
  }

  // Invoice-aware Buy now reuses the same quantity, variant and combo logic.
  window.amaAddCurrentSelection = addCurrentSelection;

  function orderSummary(cart, name, phone, email) {
    var lines = (cart.items || []).map(function (i) {
      return '- ' + i.quantity + ' x ' + i.product_title + (i.sku ? ' (' + i.sku + ')' : '');
    }).join(NL);

    return [
      'БЪРЗА ПОРЪЧКА (име и телефон)',
      '',
      'Име: ' + name,
      'Телефон: ' + phone,
      'Имейл: ' + email,
      '',
      'Продукти:',
      lines,
      '',
      'Общо: ' + (cart.total_price / 100).toFixed(2) + ' ' + (cart.currency || ''),
      'Страница: ' + window.location.href
    ].join(NL);
  }

  /* Fill the cart and the contact body, then re-click the submit button so the
     form goes out the normal way. Two things rule out shortcuts here: a fetch()
     POST to /contact is refused by Shopify's bot protection, and form.submit()
     skips submit listeners — including the hCaptcha handler Shopify attaches to
     the contact form — so the request would never carry a captcha token. */
  function onQuickOrderClick(event) {
    var submit = event.target.closest && event.target.closest('[data-ama-qo-submit]');
    if (!submit) return;
    var form = submit.closest('[data-ama-qo-form]');
    if (!form) return;
    if (form.dataset.amaQoReady === 'true') return;  // second click — let it submit

    event.preventDefault();

    var name = (form.querySelector('input[name="contact[name]"]').value || '').trim();
    var phone = (form.querySelector('input[name="contact[phone]"]').value || '').trim();
    var emailField = form.querySelector('input[name="contact[email]"]');
    var email = emailField ? (emailField.value || '').trim() : '';

    if (name.length < 2) return fail((window.amaI18n && window.amaI18n.name_error || 'Моля, въведи име.'));
    if (phone.replace(/\D/g, '').length < 8) return fail((window.amaI18n && window.amaI18n.phone_error || 'Моля, въведи валиден телефон.'));
    // deliberately loose: something@something.tld, no attempt to out-guess the RFC
    if (emailField && !/^[^@\s]+@[^@\s]+\.[^@\s]{2,}$/.test(email)) {
      return fail((window.amaI18n && window.amaI18n.email_error || 'Моля, въведи валиден имейл.'));
    }

    var errBox = form.querySelector('[data-ama-qo-error]');
    if (errBox) errBox.hidden = true;

    var previous = submit.textContent;
    submit.disabled = true;
    submit.textContent = (window.amaI18n && window.amaI18n.sending || 'Изпращаме…');

    addCurrentSelection()
      .then(function () {
        return fetch('/cart.js', { headers: { Accept: 'application/json' } })
          .then(function (r) { return r.json(); });
      })
      .then(function (cart) {
        form.querySelector('[data-ama-qo-body]').value = orderSummary(cart, name, phone, email);

        var attrs = new URLSearchParams();
        attrs.append('attributes[Бърза поръчка - име]', name);
        attrs.append('attributes[Бърза поръчка - телефон]', phone);
        attrs.append('attributes[Бърза поръчка - имейл]', email);
        return fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/x-www-form-urlencoded', Accept: 'application/json' },
          body: attrs.toString()
        }).catch(function () {});
      })
      .then(function () {
        form.dataset.amaQoReady = 'true';
        submit.disabled = false;
        submit.click();
      })
      .catch(function () {
        submit.disabled = false;
        submit.textContent = previous;
        fail((window.amaI18n && window.amaI18n.quick_error || 'Нещо се обърка. Опитай пак или ни пиши.'));
      });
  }

  function onQuickBuyClick(event) {
    var btn = event.target.closest('[data-ama-quickbuy]');
    if (!btn) return;
    event.preventDefault();
    if (btn.disabled || btn.classList.contains('is-busy')) return;

    var form = formFor(btn);
    if (!form || !new FormData(form).get('id')) {
      var add = mainAddButton(btn);   // no variant chosen — surface the normal error
      if (add) add.click();
      return;
    }
    openModal(btn);
  }

  /* Keep the quick-order button in step with add-to-cart: sold out or no
     variant chosen must disable both. */
  function sync(btn) {
    var add = mainAddButton(btn);
    if (!add) return;
    btn.disabled = add.disabled || add.getAttribute('aria-disabled') === 'true';
  }

  function watch() {
    document.querySelectorAll('[data-ama-quickbuy]').forEach(function (btn) {
      if (btn.dataset.amaQuickbuyWatched === 'true') return;
      btn.dataset.amaQuickbuyWatched = 'true';
      var add = mainAddButton(btn);
      sync(btn);
      if (!add || !window.MutationObserver) return;
      new MutationObserver(function () { sync(btn); })
        .observe(add, { attributes: true, attributeFilter: ['disabled', 'aria-disabled'] });
    });

    document.querySelectorAll('[data-ama-bundle] input[type="radio"]:checked').forEach(function (input) {
      if (input.dataset.amaBundleInit === 'true') return;
      input.dataset.amaBundleInit = 'true';
      applyChoice(input);
    });

    /* A variant swap re-renders the price block from the server, which wipes the
       bundle total. Re-apply it; syncPrice only writes when the text differs, so
       this settles in one frame instead of looping the observer. */
    var chosen = currentChoice();
    if (chosen) syncPrice(chosen);
  }

  var queued = false;
  function watchSoon() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () { queued = false; watch(); });
  }

  function start() {
    watch();
    // the contact form redirects back here after a successful send
    var done = document.querySelector('[data-ama-qo] .ama-qo__done-title');
    if (done) openModal(null);
  }

  document.addEventListener('click', onQuickBuyClick);
  document.addEventListener('click', onQuickOrderClick, true);
  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('[data-ama-qo-close]')) closeModal();
  });
  document.addEventListener('keydown', function (e) {
    var m = modal();
    if (e.key === 'Escape' && m && m.classList.contains('is-open')) closeModal();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
  // a variant swap re-renders the buy box, so re-bind on DOM changes (coalesced per frame)
  if (window.MutationObserver) {
    new MutationObserver(watchSoon).observe(document.documentElement, { childList: true, subtree: true });
  }
})();
